import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { ApiService } from "../services/api.service";
import * as $ from "jquery";

@Component({
  selector: 'app-startmeeting',
  templateUrl: './startmeeting.component.html',
  styleUrls: ['./startmeeting.component.css']
})
export class StartmeetingComponent implements OnInit {
  randomIDs: any;
  randomPasswords: any;
  model:any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public ApiServiceCall: ApiService,
  ) {
    this.model = {};
  }

  ngOnInit(): void {
    this.randomIDs = this.makeid(9);
    this.randomPasswords = this.makepassword(6);
    this.model.ID=this.randomIDs;
    this.model.password = this.randomPasswords;


  }


  startMeeting() {
    var obj = {
    meetingId: this.model.ID,
    password: this.model.password,
    userId:localStorage.getItem("userID"),
    isAudioEnabled: 1,
    isVideoEnabled: 1
    };
    $('.loading-overlay').addClass('is-active');
    this.ApiServiceCall.startMeeting(obj).subscribe((data) => {
      $('.loading-overlay').removeClass('is-active');
      localStorage.setItem('meetingId',this.model.ID);
     // alert("Join Meeting:-\n\n" + JSON.stringify(this.model));
     // alert(data.responseMessage);
      this.router.navigate(['videoroommeeting/'+this.model.ID]);

  });
  }



  makeid(length) {
    var result = '';
    var characters = '0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  makepassword(length) {
    var result = '';
    var characters = '0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  onGenerate(){

    this.randomIDs = this.makeid(9);
    this.randomPasswords = this.makepassword(6);

    this.model.ID=this.randomIDs;
    this.model.password = this.randomPasswords;

  }



}
